export const bartGreenOrangeLineExt = [
    [37.68971793886349, -122.1156636839473],
    [37.68854924855067, -122.11453364498604],
    [37.6884978551073, -122.11446549205601],
    [37.66981597573865, -122.08738765090868], // BART Hayward
    [37.66687479047885, -122.08326600857256],
    [37.66600764272579, -122.08219038578557],
    [37.63443291480717, -122.05744885570435], // BART South Hayward
    [37.62969981876153, -122.05371678611559],
    [37.62813959209695, -122.05270998134618],
    [37.621672249525425, -122.04957497938794],
    [37.62028946305407, -122.04857940235269],
    [37.619414594493335, -122.04772380842857],
    [37.605945251356616, -122.0331842682609],
    [37.59913110419056, -122.02648984634929],
    [37.59676579573375, -122.02380314669156],
    [37.593662938403675, -122.0211500369239],
    [37.590677418888504, -122.01729782238208], // BART Union City
    [37.5889516434594, -122.0149415172211],
    [37.5699768221347, -121.99023236325479],
    [37.56885245707477, -121.98896890622348],
    [37.5645106282628, -121.9853487637711],
    [37.56224951833258, -121.98290845495104],
    [37.56079685055236, -121.98121083525177],
    [37.559926012318904, -121.98016731701888],
    [37.55745115466731, -121.97665384346965], // BART Fremont
    [37.55597576899256, -121.97439640495679],
    [37.555135454107536, -121.97262979079835],
    [37.55478482457429, -121.97100369404087],
    [37.55446765843392, -121.96773801131448],
    [37.55427937692104, -121.96606619987482],
    [37.55370656070698, -121.96384154075689],
    [37.55321174199215, -121.96292385148128],
    [37.55181748841622, -121.96101790096459],
    [37.54751817098048, -121.95691662716841],
    [37.546605781631605, -121.95629875731599],
    [37.545038907945695, -121.9557114433646],
    [37.538859657458445, -121.9542990932516],
    [37.53044547802437, -121.95361963443025],
    [37.529169184610865, -121.95339522949465],
    [37.527924582684825, -121.95289519152293],
    [37.50573747027945, -121.94134848416064],
    [37.504729956606596, -121.94074538830253],
    [37.50215317761454, -121.93939113101814], // BART Warm Springs / South Fremont
    [37.49336665155772, -121.93491865619502],
    [37.431650252696876, -121.90294558619675],
    [37.410292232541615, -121.8910371003665], // BART Milpitas
    [37.40852628512994, -121.89014220039485],
    [37.3996406024392, -121.8852301320418],
    [37.36842629691206, -121.8748247263502], // BART Berryessa / North San Jose
];